import { createContext } from "react";

const CognitoContext = createContext(null);

export default CognitoContext;
